module.exports = __webpack_public_path__ + "img/about2.d313fd26.png";